import { ArrowRightOnRectangleIcon, Bars3Icon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "./LanguageSwitcher";
import NotificationBell from "./notifications/NotificationBell";
import ThemeSwitcher from "./ThemeSwitcher";

/**
 * Account strip that used to live at the foot of the sidebar. `ms-auto` pins it
 * to the inline end, so it sits right in English and left in Arabic off the
 * <html dir> alone.
 */
export default function Topbar({ user, onLogout, onToggleSidebar }) {
  const { t } = useTranslation();

  const name = user?.name || t("app.businessUser");
  const avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(
    name
  )}&background=0FA97B&color=14213A&size=40`;

  return (
    <header className="sticky top-0 z-20 flex items-center gap-2 border-b border-line bg-surface px-4 py-2 md:px-6">
      <button
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar"
        className="rounded-lg p-1 hover:bg-raised md:hidden"
      >
        <Bars3Icon className="h-6 w-6 text-ink" />
      </button>

      <div className="ms-auto flex items-center gap-2 sm:gap-3">
        <img src={avatar} alt="" className="h-9 w-9 flex-shrink-0 rounded-full object-cover" />
        {/* Identity text is the first thing to go on a narrow screen. */}
        <div className="hidden flex-col overflow-hidden sm:flex">
          <p className="truncate text-sm font-semibold text-ink">{name}</p>
          <p className="max-w-[10rem] truncate text-xs text-ink-2">{user?.email}</p>
        </div>

        <NotificationBell />
        <LanguageSwitcher compact />
        <ThemeSwitcher compact />

        <button
          onClick={onLogout}
          aria-label={t("app.logout")}
          title={t("app.logout")}
          className="flex min-h-touch items-center gap-2 rounded-control border border-danger px-2 py-1
            text-xs font-bold text-danger-text transition-colors duration-fast hover:bg-danger-wash sm:px-3"
        >
          {/* The glyph points out of the box, so it mirrors with the document. */}
          <ArrowRightOnRectangleIcon className="h-4 w-4 stroke-2 rtl:-scale-x-100" />
          <span className="hidden sm:inline">{t("app.logout")}</span>
        </button>
      </div>
    </header>
  );
}
